// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-spacing[data-v-0cdea846]{margin-top:-1.5rem;margin-bottom:0}.btn-ok[data-v-0cdea846]{background-color:#00afef!important}.custom-control-input:checked~.custom-control-label[data-v-0cdea846]:before{color:#006891;border-color:#006891;background-color:#fff;box-shadow:0 3px 2px rgba(233,236,239,.05)}", ""]);
// Exports
module.exports = exports;
